import script from "./VaporAudioField.vue?vue&type=script&lang=js"
export * from "./VaporAudioField.vue?vue&type=script&lang=js"

import exportComponent from "/home/malezha/zfort/digitalfax/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"VaporAudioField.vue"]])

export default __exports__